// 3rd
import { Model } from '@vuex-orm/core';
// models
import { User } from './index';
import ContractType from './ContractType';
// utils
import { api, authHeaders, errorHandler } from '../utils/api';
import {
    LOADER_FETCH_CONTRACT_APPROVALS,
    API_ENDPOINT_FETCH_CONTRACT_APPROVALS,
    API_ENDPOINT_FETCH_CONTRACTS,
    LOADER_FETCH_PENDING_CONTRACTS,
    LOCAL_STORAGE_USER,
    LOADER_APPROVE_CONTRACT,
    API_ENDPOINT_POST_CONTRACT_APPROVE,
    LOADER_DECLINE_CONTRACT,
    API_ENDPOINT_POST_CONTRACT_DECLINE,
    LOADER_SUBMIT_CONTRACT,
    API_ENDPOINT_POST_CONTRACT
} from '../utils/constants';

export default class Contract extends Model {
    static entity = 'contracts';

    static fields() {
        return {
            id: this.attr(null),
            ab_number: this.string(''),
            customer_type: this.string(''),
            payment_type: this.string(''),
            customer_zip: this.string(''),
            potential_delivery_date: this.attr(''),
            approved: this.boolean(false),
            declined: this.boolean(false),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            user_id: this.attr(null),
            contract_type_id: this.attr(null),

            avatar: this.string(
                '//via.placeholder.com/100/000000/FFFFFF/?text=MISSING'
            ),
            model_name: this.string('MISSING'),
            vin: this.attr(null),
            commission: this.attr(null),
            order_date_customer: this.string('MISSING'),

            // relations
            user: this.belongsTo(User, 'user_id'),
            contract_type: this.belongsTo(ContractType, 'contract_type_id')
        };
    }

    // api calls
    static async fetchApprovals() {
        Contract.store().dispatch(
            'wait/start',
            LOADER_FETCH_CONTRACT_APPROVALS
        );

        const response = await api
            .get(API_ENDPOINT_FETCH_CONTRACT_APPROVALS, authHeaders())
            .catch(errorHandler);
        if (!response) return;

        const { data } = response;
        const { approvals, reasons } = data;

        Contract.insert({
            data: approvals
        });

        Contract.store().dispatch('wait/end', LOADER_FETCH_CONTRACT_APPROVALS);

        return reasons;
    }

    static async approve(approvalId) {
        Contract.store().dispatch(
            'wait/start',
            `${LOADER_APPROVE_CONTRACT}${approvalId}`
        );

        const response = await api
            .post(
                API_ENDPOINT_POST_CONTRACT_APPROVE,
                { id: approvalId },
                authHeaders()
            )
            .catch(errorHandler);
        if (!response) return;

        Contract.update({
            where: approvalId,
            data: {
                approved: true
            }
        });

        Contract.store().dispatch(
            'wait/end',
            `${LOADER_APPROVE_CONTRACT}${approvalId}`
        );
    }

    static async decline(approvalId, reasonId) {
        Contract.store().dispatch(
            'wait/start',
            `${LOADER_DECLINE_CONTRACT}${approvalId}`
        );

        const response = await api
            .post(
                API_ENDPOINT_POST_CONTRACT_DECLINE,
                { reason_id: reasonId, id: approvalId },
                authHeaders()
            )
            .catch(errorHandler);
        if (!response) return;

        Contract.update({
            where: approvalId,
            data: {
                declined: true
            }
        });

        Contract.store().dispatch(
            'wait/end',
            `${LOADER_DECLINE_CONTRACT}${approvalId}`
        );
    }

    static async submission(form) {
        Contract.store().dispatch('wait/start', LOADER_SUBMIT_CONTRACT);

        return await api.post(API_ENDPOINT_POST_CONTRACT, form, authHeaders());
    }

    static async fetchPendings() {
        Contract.store().dispatch('wait/start', LOADER_FETCH_PENDING_CONTRACTS);

        const response = await api
            .get(API_ENDPOINT_FETCH_CONTRACTS, authHeaders())
            .catch(errorHandler);
        if (!response) return;

        const { data } = response;
        const { contracts } = data;

        Contract.insert({
            data: contracts
        });

        Contract.store().dispatch('wait/end', LOADER_FETCH_PENDING_CONTRACTS);
    }

    // getters
    static getPendings() {
        const localUser = Number(localStorage.getItem(LOCAL_STORAGE_USER));
        return Contract.query()
            .where('user_id', localUser)
            .withAll()
            .get();
    }

    static getApprovals() {
        return Contract.query()
            .orderBy('created_at', 'desc')
            .with('user.profile')
            .get();
    }
}
